export const modelName = 'Mini Chassis Kit.glb';

/** Public, direct-download .glb URLs tried in order. This is the default model everyone sees. */
export const modelSources: string[] = [
'https://raw.githubusercontent.com/arminjamak/knsksa/main/Meshy_AI_3D_Printed_Mini_Chass_1001152351_generate.glb'];
